import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=43eac8e8&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=43eac8e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eac8e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43eac8e8')) {
      api.createRecord('43eac8e8', component.options)
    } else {
      api.reload('43eac8e8', component.options)
    }
    module.hot.accept("./BasicLayout.vue?vue&type=template&id=43eac8e8&scoped=true", function () {
      api.rerender('43eac8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/BasicLayout.vue"
export default component.exports